import {
  IEmployeeTimeOff,
  IEmployeeTimeOffBookingBalanceData,
  IEmployeeTimeOffData,
  IEmployeeTimeOffEntitlementData
} from '@/models';
import {
  ICreateMultipleEmployeeTimeOffEntitlementsPayload,
  IEmployeeTimeOffService,
  IFetchEmployeeTimeOffEntitlementsPayload
} from './employee-timeoff.types';
import { AxiosInstance } from 'axios';

export class EmployeeTimeOffService implements IEmployeeTimeOffService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/employees/';
  }

  fetchEmployeeTimeOff(id: number): Promise<IEmployeeTimeOffData> {
    return this.axios
      .get<IEmployeeTimeOff>(`${this.endpoint}${id}/timeoff/`)
      .then(({ data }) => data);
  }

  fetchEmployeeTimeOffBalance(
    id: number,
    year: number
  ): Promise<IEmployeeTimeOffBookingBalanceData> {
    return this.axios
      .get<IEmployeeTimeOffBookingBalanceData>(
        `${this.endpoint}${id}/timeoff/balances/`,
        {
          params: { year: year }
        }
      )
      .then(({ data }) => data);
  }

  updateEmployeeTimeOff(
    data: IEmployeeTimeOffData
  ): Promise<IEmployeeTimeOffData> {
    return this.axios
      .patch<IEmployeeTimeOffData>(
        `${this.endpoint}${data.employee}/timeoff/`,
        data
      )
      .then(({ data }) => data);
  }

  createMultipleEmployeeTimeOffEntitlements(
    data: ICreateMultipleEmployeeTimeOffEntitlementsPayload
  ): Promise<IEmployeeTimeOffEntitlementData[]> {
    return this.axios
      .post<IEmployeeTimeOffEntitlementData[]>(
        `${this.endpoint}${data.employee}/timeoff/entitlements/create-multiple/`,
        data.entitlements,
        {
          params: {
            year: data.year
          }
        }
      )
      .then(({ data }) => data);
  }

  fetchEmployeeTimeOffEntitlements(
    data: IFetchEmployeeTimeOffEntitlementsPayload
  ): Promise<IEmployeeTimeOffEntitlementData[]> {
    return this.axios
      .get<IEmployeeTimeOffEntitlementData[]>(
        `${this.endpoint}${data.employee}/timeoff/entitlements/`,
        {
          params: { year: data.year }
        }
      )
      .then(({ data }) => data);
  }

  fetchEmployeeTimeOffEntitlementYears(id: number): Promise<number[]> {
    return this.axios
      .get<number[]>(`${this.endpoint}${id}/timeoff/entitlements/get-years/`)
      .then(({ data }) => data);
  }

  fetchEmployeeTimeOffEntitlementVacationYear(id: number): Promise<number> {
    return this.axios
      .get<number>(
        `${this.endpoint}${id}/timeoff/entitlements/vacation/get-entitlement-year/`
      )
      .then(({ data }) => data);
  }
}
